export const enum CHALLENGE_WINNER_MODE {
  highest_score = 'highest_score',
  random = 'random',
}
